/** 是否正式 B：优先读 define 注入的 env，再兜底 bueatyadmin 域名 */
export function isProdBEnv(): boolean {
  const raw = process.env.REACT_APP_ENV;
  const env = String(raw ?? '')
    .replace(/^["']|["']$/g, '')
    .trim()
    .toLowerCase();
  if (env === 'prod-b') return true;

  // 与 REACT_APP_ENV 同步注入，避免部分打包器漏替换 process.env.REACT_APP_ENV
  const flag = String(process.env.ADMIN_IS_PROD_B ?? '')
    .replace(/^["']|["']$/g, '')
    .trim();
  if (flag === '1' || flag === 'true') return true;

  if (typeof window !== 'undefined') {
    const host = window.location.hostname.toLowerCase();
    return host.startsWith('bueatyadmin.') || host.includes('.bueatyadmin.');
  }
  return false;
}
